export class UserStorage {

  static LOCAL_STORAGE_USERID = 'userId';

  static getUserId()
  {
    return localStorage.getItem(UserStorage.LOCAL_STORAGE_USERID);
  }

  static storeUserId(userId)
  {
    localStorage.setItem(UserStorage.LOCAL_STORAGE_USERID, userId);
  }

  static clear()
  {
    localStorage.removeItem(UserStorage.LOCAL_STORAGE_USERID);
  }
}
